import { render, staticRenderFns } from "./IconVideo.vue?vue&type=template&id=5a3b2e7f"
import script from "./IconVideo.vue?vue&type=script&lang=js"
export * from "./IconVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports